import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
import type { FormField, ThemeConfig } from '../../../types/forms';
import { getInputStyles } from '../../../lib/themeUtils';
import { useScrollIntoViewOnFocus } from '../../../hooks/useScrollIntoViewOnFocus';

interface DateFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

export const DateField: React.FC<DateFieldProps> = ({
  field,
  value = '',
  onChange,
  error,
  disabled,
  themeConfig,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputStyles = getInputStyles(themeConfig, { error: !!error, focused: isFocused });
  const scrollOnFocus = useScrollIntoViewOnFocus<HTMLInputElement>();

  const inputType = field.type === 'datetime' ? 'datetime-local' :
                    field.type === 'time' ? 'time' : 'date';

  return (
    <div className="relative min-w-0 max-w-full">
      <input
        type={inputType}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={(e) => { setIsFocused(true); scrollOnFocus(e); }}
        onBlur={() => setIsFocused(false)}
        required={field.required}
        disabled={disabled}
        className="w-full min-w-0 max-w-full px-4 py-3 pr-12 focus:outline-none transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        style={{ ...inputStyles, colorScheme: 'dark', boxSizing: 'border-box' }}
      />
      <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: inputStyles.color, opacity: 0.5 }}>
        <Calendar className="w-5 h-5" />
      </div>
    </div>
  );
};
